import { UnifiedQuoteResponse } from '@velocity-exchange/sdk';
import InlineAlert from 'src/components/primitives/InlineAlert/InlineAlert';
import { memo } from 'react';
import Button from 'src/components/primitives/Button/Button';

// Display helpful error messages when the swap quote failed
const SwapQuoteErrorDisplay = ({
	quoteDetails,
	swapMode,
	useDirectRoute,
	className,
	onTryExactIn,
}: {
	quoteDetails: UnifiedQuoteResponse;
	swapMode: 'ExactIn' | 'ExactOut';
	useDirectRoute: boolean;
	className?: string;
	onTryExactIn?: () => void;
}) => {
	if (quoteDetails?.error) {
		// Known error codes
		if (
			quoteDetails.errorCode === 'NO_ROUTES_FOUND' ||
			quoteDetails.errorCode === 'COULD_NOT_FIND_ANY_ROUTE'
		) {
			if (swapMode === 'ExactOut') {
				return (
					<InlineAlert
						variant="warning"
						title="No routes found using ExactOut swap mode for this pair"
						className={className}
					>
						<div>No routes found using ExactOut swap mode for this pair</div>
						<Button
							size="sm"
							variant="secondary"
							className="w-fit"
							onClick={onTryExactIn}
						>
							Try ExactIn Swap
						</Button>
					</InlineAlert>
				);
			} else if (useDirectRoute) {
				return (
					<InlineAlert
						variant="warning"
						title="No routes found"
						className={className}
					>
						No routes found, try disabling direct route or swapping with smaller
						size
					</InlineAlert>
				);
			} else {
				return (
					<InlineAlert
						variant="warning"
						className={className}
						title="No routes found"
					>
						No routes found for this pair
					</InlineAlert>
				);
			}
		}

		if (
			quoteDetails.errorCode === 'ROUTE_PLAN_DOES_NOT_CONSUME_ALL_THE_AMOUNT'
		) {
			return (
				<InlineAlert
					variant="warning"
					title="Max Number of Accounts"
					className={className}
				>
					<div>
						Route would exceed max number of accounts allowed per transaction
					</div>
					<div>
						Try closing any open positions and settling balances in your Drift
						account, then try again, or use a different swap pair
					</div>
				</InlineAlert>
			);
		}

		if (quoteDetails.errorCode === 'SLIPPAGE_TOO_LOW') {
			return (
				<InlineAlert
					variant="warning"
					className={className}
					title="Slippage is too low (<0.01%)"
				/>
			);
		}

		// Default case, unknown error code
		return (
			<InlineAlert
				variant="warning"
				className={className}
				title="Swap quote could not be loaded, please try again later"
			>
				Error code: {quoteDetails.errorCode ?? 'UNKNOWN_ERROR_CODE'}
			</InlineAlert>
		);
	}

	return null;
};

export default memo(SwapQuoteErrorDisplay);
